import type { FlightLeg } from "./types";

/**
 * Oct–Dec 2025 rows with `[Time share]` in route notes — the twelve Q4 legs used for the
 * Comparison tab and `fourQuarterTimeshareN426dh.logbook.test.ts` (fixture CSV).
 */
export function filterQ4_2025TimeShareLegsFromLogbook(all: FlightLeg[]): FlightLeg[] {
  return all.filter((leg) => {
    const d = leg.flightDate;
    if (d < "2025-10-01" || d > "2025-12-31") return false;
    return /\[Time share\]/i.test(leg.routeNotes ?? "");
  });
}

/** Jan–Mar 2026 rows with `[Time share]` in route notes — Comparison tab Q1 reference block. */
export function filterQ1_2026TimeShareLegsFromLogbook(all: FlightLeg[]): FlightLeg[] {
  return all.filter((leg) => {
    const d = leg.flightDate;
    if (d < "2026-01-01" || d > "2026-03-31") return false;
    return /\[Time share\]/i.test(leg.routeNotes ?? "");
  });
}
